// Sidebar functionality
// @ts-nocheck
import { t } from '../../services/i18n';

export class Sidebar {
    constructor() {
        this.sidebar = document.getElementById('sidebar');
        this.toggleBtn = document.getElementById('toggleSidebar');
        this.resizer = document.getElementById('sidebar-resizer');
        this.tabButtons = document.querySelectorAll('.tab-btn');
        this.tabContents = document.querySelectorAll('.tab-content');
        this.searchInput = document.getElementById('streamer-search');
        this.homeButton = document.getElementById('sidebar-home');
        this.comboQuickAccess = document.querySelector('.combo-quick-access');
        this.comboMenuTrigger = document.getElementById('combo-menu-trigger');
        this.comboQuickMenu = document.getElementById('combo-quick-menu');
        this.comboQuickSearch = document.getElementById('combo-quick-search');
        this.comboQuickList = document.getElementById('combo-quick-list');
        this.activeSearchResultIndex = -1;
        this.searchRequestController = null;
        
        // Liez les méthodes une seule fois et conservez la référence
        this.boundResize = this.resize.bind(this);
        this.boundStopResize = this.stopResize.bind(this);
        this.boundSearchStreamers = this.debounce(this.searchStreamers.bind(this), 300);
        
        // Initialiser l'état de la sidebar
        this.initSidebarState();
        this.initEventListeners();
        this.initSearchResults();
        this.initComboQuickMenu();
    }

    initEventListeners() {
        // Toggle sidebar visibility with improved handling
        this.toggleBtn.addEventListener('click', () => {
            this.toggleSidebar();
        });

        this.homeButton?.addEventListener('click', () => window.app?.showHome?.());

        // Tab switching
        this.tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                const tabName = button.getAttribute('data-tab');
                this.activateTab(tabName);
            });
        });

        // Resizing functionality
        this.resizer.addEventListener('mousedown', this.startResize.bind(this));
        
        // Search functionality
        this.searchInput.addEventListener('input', () => {
            this.activeSearchResultIndex = -1;
            this.boundSearchStreamers();
        });
        this.searchInput.addEventListener('keydown', this.handleSearchKeydown.bind(this));
        // Fermer les résultats quand on clique ailleurs
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.search-box') && this.searchResults) {
                this.setSearchResultsVisible(false);
            }
            if (!e.target.closest('.combo-quick-access')) {
                this.setComboMenuOpen(false);
            }
        });
        
        // Chat controls
        this.initChatControls();
    }

    initComboQuickMenu() {
        if (!this.comboQuickAccess) return;

        this.comboMenuTrigger?.addEventListener('click', (event) => {
            event.stopPropagation();
            this.setComboMenuOpen(!this.comboQuickAccess.classList.contains('is-open'));
        });
        this.comboQuickAccess.addEventListener('mouseenter', () => this.renderComboQuickMenu());
        this.comboQuickAccess.addEventListener('focusin', () => this.renderComboQuickMenu());
        this.comboQuickSearch?.addEventListener('input', () => this.renderComboQuickMenu());
        document.addEventListener('pointerdown', (event) => {
            const action = event.target instanceof Element
                ? event.target.closest('.combo-quick-menu [data-combo-action]')
                : null;
            if (!action) return;
            event.preventDefault();
            event.stopPropagation();
            this.runComboQuickAction(action);
        }, true);
        this.comboQuickMenu?.addEventListener('click', (event) => {
            // Les clics souris/tactiles sont traités au pointerdown, avant la fermeture du flyout.
            if (event.detail !== 0) return;
            const action = event.target instanceof Element
                ? event.target.closest('[data-combo-action]')
                : null;
            if (action) this.runComboQuickAction(action);
        });
        window.addEventListener('combos-updated', () => this.renderComboQuickMenu());
        window.addEventListener('interface-language-change', () => this.renderComboQuickMenu());
        this.renderComboQuickMenu();
    }

    runComboQuickAction(action) {
        const combos = window.streamCombos;
        const comboId = action.dataset.comboId;
        const actionName = action.dataset.comboAction;

        action.classList.add('is-activating');
        if (actionName === 'load' && comboId != null) combos?.loadCombo(comboId);
        if (actionName === 'edit' && comboId != null) combos?.openCreateComboModal(comboId);
        if (actionName === 'create') combos?.openCreateComboModal();
        if (actionName === 'save-current') {
            combos?.openCreateComboModal(null, window.app?.getCurrentStreamerLogins?.() || []);
        }
        if (actionName === 'manage') {
            combos?.openComboModal();
            combos?.switchTab('my-combos');
        }
        this.setComboMenuOpen(false);
    }

    setComboMenuOpen(isOpen) {
        this.comboQuickAccess?.classList.toggle('is-open', isOpen);
        this.comboMenuTrigger?.setAttribute('aria-expanded', String(isOpen));
        if (isOpen) {
            this.renderComboQuickMenu();
            window.setTimeout(() => this.comboQuickSearch?.focus(), 0);
        }
    }

    renderComboQuickMenu() {
        if (!this.comboQuickList) return;
        const query = this.comboQuickSearch?.value.trim().toLocaleLowerCase() || '';
        const combos = (window.streamCombos?.userCombos || []).filter(combo => {
            const searchable = `${combo.name} ${combo.description || ''} ${(combo.streamers || []).join(' ')}`.toLocaleLowerCase();
            return searchable.includes(query);
        });

        this.comboQuickList.replaceChildren();
        if (combos.length === 0) {
            const empty = document.createElement('p');
            empty.className = 'combo-quick-empty';
            empty.textContent = t(query ? 'combos.noSearchResult' : 'combos.quickEmpty');
            this.comboQuickList.appendChild(empty);
            return;
        }

        combos.slice(0, 8).forEach(combo => {
            const row = document.createElement('div');
            row.className = 'combo-quick-item';
            const info = document.createElement('button');
            info.type = 'button';
            info.className = 'combo-quick-load';
            info.dataset.comboAction = 'load';
            info.dataset.comboId = combo.id;
            info.innerHTML = '<i class="fas fa-play"></i>';
            const copy = document.createElement('span');
            const name = document.createElement('strong');
            name.textContent = combo.name;
            const meta = document.createElement('small');
            meta.textContent = t('combos.streamerCount', { count: combo.streamers?.length || 0 });
            copy.append(name, meta);
            info.appendChild(copy);
            const edit = document.createElement('button');
            edit.type = 'button';
            edit.className = 'combo-quick-edit';
            edit.dataset.comboAction = 'edit';
            edit.dataset.comboId = combo.id;
            edit.title = t('combos.edit');
            edit.setAttribute('aria-label', edit.title);
            edit.innerHTML = '<i class="fas fa-pen"></i>';
            row.append(info, edit);
            this.comboQuickList.appendChild(row);
        });
    }
    
    // Ajouter une fonction de debounce pour limiter les requêtes API
    debounce(func, delay) {
        let timeout;
        return function() {
            const context = this;
            const args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), delay);
        };
    }
    
    // Initialiser le container des résultats de recherche
    initSearchResults() {
        this.searchResults = document.createElement('div');
        this.searchResults.className = 'search-results';
        this.searchResults.id = 'streamer-search-results';
        this.searchResults.setAttribute('role', 'listbox');
        this.searchInput.setAttribute('aria-controls', this.searchResults.id);
        this.searchInput.setAttribute('aria-autocomplete', 'list');
        this.searchInput.setAttribute('aria-expanded', 'false');
        const searchBox = document.querySelector('.search-box');
        searchBox.appendChild(this.searchResults);
    }

    setSearchResultsVisible(isVisible) {
        this.searchResults.classList.toggle('show', isVisible);
        this.searchInput.setAttribute('aria-expanded', String(isVisible));

        if (!isVisible) {
            this.activeSearchResultIndex = -1;
            this.searchInput.removeAttribute('aria-activedescendant');
        }
    }

    getSearchResultItems() {
        return Array.from(this.searchResults.querySelectorAll('.search-result-item'));
    }

    updateActiveSearchResult(index) {
        const items = this.getSearchResultItems();
        if (items.length === 0) return;

        this.activeSearchResultIndex = (index + items.length) % items.length;
        items.forEach((item, itemIndex) => {
            const isActive = itemIndex === this.activeSearchResultIndex;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', String(isActive));
        });

        const activeItem = items[this.activeSearchResultIndex];
        this.searchInput.setAttribute('aria-activedescendant', activeItem.id);
        activeItem.scrollIntoView({ block: 'nearest' });
    }

    selectSearchResult(item) {
        const login = item.dataset.streamerLogin;
        if (!login) return;

        this.searchInput.value = login;
        this.setSearchResultsVisible(false);
        document.getElementById('add-streamer').click();
    }

    handleSearchKeydown(event) {
        if (!this.searchResults.classList.contains('show')) return;

        const items = this.getSearchResultItems();
        if (items.length === 0) return;

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.updateActiveSearchResult(this.activeSearchResultIndex + 1);
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.updateActiveSearchResult(
                this.activeSearchResultIndex < 0 ? items.length - 1 : this.activeSearchResultIndex - 1
            );
        } else if (event.key === 'Enter') {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.selectSearchResult(items[this.activeSearchResultIndex < 0 ? 0 : this.activeSearchResultIndex]);
        } else if (event.key === 'Escape') {
            event.preventDefault();
            this.setSearchResultsVisible(false);
        }
    }
    
    // Fonction pour rechercher des streamers
    async searchStreamers() {
        const query = this.searchInput.value.trim();
        
        if (!query || query.length < 2) {
            this.searchRequestController?.abort();
            this.setSearchResultsVisible(false);
            return;
        }

        this.searchRequestController?.abort();
        this.searchRequestController = new AbortController();
        
        // Afficher le chargement
        this.searchResults.innerHTML = `<div class="search-loading"><div class="spinner"></div>${t('stream.searching')}</div>`;
        this.setSearchResultsVisible(true);
        
        try {
            const response = await fetch(`/api/streamers/search?query=${encodeURIComponent(query)}`, {
                signal: this.searchRequestController.signal
            });
            
            if (!response.ok) {
                throw new Error('Failed to search streamers');
            }
            
            const data = await response.json();
            
            if (!data.success) {
                throw new Error(data.error || 'Unknown error');
            }
            
            this.renderSearchResults(data.results);
            
        } catch (error) {
            if (error.name === 'AbortError') return;
            console.error('Search error:', error);
            this.searchResults.innerHTML = `<div class="search-no-results">${t('common.error', { message: error.message })}</div>`;
        }
    }
    
    // Afficher les résultats de recherche
    renderSearchResults(results) {
        this.activeSearchResultIndex = -1;
        this.searchInput.removeAttribute('aria-activedescendant');

        if (results.length === 0) {
            this.searchResults.innerHTML = `<div class="search-no-results">${t('stream.noResults')}</div>`;
            return;
        }
        
        this.searchResults.innerHTML = '';
        
        results.forEach((streamer, index) => {
            const item = document.createElement('div');
            item.className = `search-result-item ${streamer.is_live ? 'live' : ''}`;
            item.id = `streamer-search-result-${index}`;
            item.dataset.streamerLogin = streamer.login;
            item.setAttribute('role', 'option');
            item.setAttribute('aria-selected', 'false');
            
            const gameInfo = streamer.is_live ? streamer.game_name : t('stream.offlineSearch');
            const liveBadge = streamer.is_live ? '<span class="search-result-badge">LIVE</span>' : '';
            
            item.innerHTML = `
                <img class="search-result-avatar" src="${streamer.profile_image_url}" alt="${streamer.display_name}">
                <div class="search-result-info">
                    <div class="search-result-name">${streamer.display_name} ${liveBadge}</div>
                    <div class="search-result-status">${gameInfo}</div>
                </div>
            `;
            
            // Ajouter l'événement de clic pour ajouter le streamer
            item.addEventListener('click', () => {
                this.selectSearchResult(item);
            });

            item.addEventListener('mouseenter', () => this.updateActiveSearchResult(index));
            
            this.searchResults.appendChild(item);
        });
    }

    toggleSidebar() {
        // Force a reflow before toggling the class to ensure clean transition
        void this.sidebar.offsetWidth;
        this.sidebar.classList.toggle('collapsed');
        
        // Save sidebar state to localStorage for persistence
        const isCollapsed = this.sidebar.classList.contains('collapsed');
        localStorage.setItem('sidebarCollapsed', isCollapsed);
        
        // Mettre à jour les mini-streamers
        this.updateMiniStreamers();
        
        // Trigger window resize event to ensure layout updates properly
        window.dispatchEvent(new Event('resize'));
    }

    initSidebarState() {
        const isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';
        if (isCollapsed) {
            this.sidebar.classList.add('collapsed');
        }
        
        // Initialiser les classes de largeur basées sur la largeur actuelle
        const currentWidth = parseInt(this.sidebar.style.width) || parseInt(getComputedStyle(this.sidebar).width);
        this.updateSidebarWidthClasses(currentWidth);
        
        // Créer le conteneur pour les streamers en mode minimisé
        this.miniStreamersContainer = document.createElement('div');
        this.miniStreamersContainer.className = 'streamers-container';
        this.sidebar.appendChild(this.miniStreamersContainer);
        
        // Vérifier si la sidebar est en mode minimisé et mettre à jour l'affichage
        this.updateMiniStreamers();
    }

    activateTab(tabName) {
        // Remove active class from all tabs
        this.tabButtons.forEach(btn => btn.classList.remove('active'));
        this.tabContents.forEach(content => content.classList.remove('active'));
        
        // Add active class to selected tab
        document.querySelector(`.tab-btn[data-tab="${tabName}"]`).classList.add('active');
        document.getElementById(`${tabName}-tab`).classList.add('active');
        
        // Gérer l'affichage des contrôles de chat
        const chatModeControls = document.querySelector('.chat-mode-controls');
        if (chatModeControls) {
            if (tabName === 'chat') {
                chatModeControls.classList.remove('hidden');
            } else {
                chatModeControls.classList.add('hidden');
            }
        }
        
        // Si on active l'onglet chat, vérifier s'il faut activer le mode global
        if (tabName === 'chat') {
            // Seulement activer le mode global si aucun chat n'est déjà actif
            const chatContainer = document.getElementById('chat-container');
            if (!chatContainer || (!chatContainer.classList.contains('global-chat') && chatContainer.innerHTML.trim() === '')) {
                // Activer le mode chat global par défaut seulement si le conteneur est vide
                setTimeout(() => {
                    this.activateChatMode('global');
                }, 100); // Petit délai pour s'assurer que l'onglet est bien activé
            }
        }
    }

    startResize(e) {
        e.preventDefault();
        this.sidebar.classList.add('is-resizing');
        document.body.classList.add('sidebar-resizing');
        // Utilisez les références liées créées dans le constructeur
        window.addEventListener('mousemove', this.boundResize);
        window.addEventListener('mouseup', this.boundStopResize);
    }

    resize(e) {
        const newWidth = e.clientX;
        
        if (newWidth >= 336 && newWidth <= 500) {
            this.sidebar.style.width = `${newWidth}px`;
            document.documentElement.style.setProperty('--sidebar-width', `${newWidth}px`);
            
            // Ajouter des classes CSS basées sur la largeur pour adapter les boutons de chat
            this.updateSidebarWidthClasses(newWidth);
        }
    }
    
    updateSidebarWidthClasses(width) {
        // Supprimer toutes les classes de largeur existantes
        this.sidebar.classList.remove('sidebar-very-narrow', 'sidebar-ultra-narrow', 'sidebar-minimized', 'sidebar-compact');
        
        // Ajouter la classe appropriée basée sur la largeur
        if (width <= 180) {
            this.sidebar.classList.add('sidebar-ultra-narrow');
        } else if (width <= 220) {
            this.sidebar.classList.add('sidebar-very-narrow');
        } else {
            if (width < 420) this.sidebar.classList.add('sidebar-minimized');
            if (width <= 370) this.sidebar.classList.add('sidebar-compact');
        }
    }

    stopResize() {
        this.sidebar.classList.remove('is-resizing');
        document.body.classList.remove('sidebar-resizing');
        // Supprimez les mêmes références liées
        window.removeEventListener('mousemove', this.boundResize);
        window.removeEventListener('mouseup', this.boundStopResize);
    }
    
    // Méthode pour initialiser le drag and drop des streamers
    initDragAndDrop(streamersList, onOrderChange) {
        this.streamersList = streamersList;
        this.onOrderChange = onOrderChange;
        
        // Délégation d'événements pour les éléments de la liste
        this.streamersList.addEventListener('dragstart', this.handleDragStart.bind(this));
        this.streamersList.addEventListener('dragover', this.handleDragOver.bind(this));
        this.streamersList.addEventListener('dragleave', this.handleDragLeave.bind(this));
        this.streamersList.addEventListener('drop', this.handleDrop.bind(this));
        this.streamersList.addEventListener('dragend', this.handleDragEnd.bind(this));
    }

    clearDragIndicators(container = this.streamersList) {
        container?.querySelectorAll('.drop-above, .drop-below, .drag-target-above, .drag-target-below')
            .forEach(item => item.classList.remove('drop-above', 'drop-below', 'drag-target-above', 'drag-target-below'));
    }
    
    handleDragStart(e) {
        if (e.target.closest('button, input, a')) {
            e.preventDefault();
            return;
        }

        const item = e.target.closest('.streamer-item');
        if (!item) return;
        
        // Identifier l'élément en cours de déplacement
        e.dataTransfer.setData('text/plain', item.dataset.streamerId);
        e.dataTransfer.effectAllowed = 'move';
        item.setAttribute('aria-grabbed', 'true');
        this.streamersList.classList.add('is-reordering');

        const dragPreview = document.createElement('div');
        dragPreview.className = 'streamer-drag-preview';
        const previewAvatar = item.querySelector('.streamer-avatar')?.cloneNode(true);
        const previewName = document.createElement('span');
        previewName.textContent = item.querySelector('.streamer-name')?.textContent || '';
        if (previewAvatar) dragPreview.appendChild(previewAvatar);
        dragPreview.appendChild(previewName);
        document.body.appendChild(dragPreview);
        e.dataTransfer.setDragImage(dragPreview, 24, 24);
        window.setTimeout(() => dragPreview.remove(), 0);
        
        // Ajouter une classe pour le style pendant le drag
        item.classList.add('dragging');
        
        // Délai pour que la classe soit appliquée avant que l'image du drag ne soit générée
        setTimeout(() => {
            item.classList.add('drag-active');
        }, 0);
    }
    
    handleDragOver(e) {
        e.preventDefault();
        const item = e.target.closest('.streamer-item');
        if (!item || item.classList.contains('dragging')) return;
        
        e.dataTransfer.dropEffect = 'move';
        
        // Détermine la position du survol (en haut ou en bas de l'élément)
        const rect = item.getBoundingClientRect();
        const y = e.clientY - rect.top;
        const isTop = y < rect.height / 2;
        
        this.clearDragIndicators();
        
        // Ajoute la classe appropriée
        item.classList.add(isTop ? 'drop-above' : 'drop-below');
    }
    
    handleDragLeave(e) {
        const item = e.target.closest('.streamer-item');
        if (!item) return;
        if (e.relatedTarget && item.contains(e.relatedTarget)) return;
        
        // Enlève les indicateurs visuels
        item.classList.remove('drop-above', 'drop-below');
    }
    
    handleDrop(e) {
        e.preventDefault();
        const sourceId = e.dataTransfer.getData('text/plain');
        const sourceItem = document.querySelector(`.streamer-item[data-streamer-id="${sourceId}"]`);
        const targetItem = e.target.closest('.streamer-item');
        
        if (!sourceItem || !targetItem || sourceItem === targetItem) {
            this.clearDragIndicators();
            return;
        }
        
        // Détermine si on dépose au-dessus ou en-dessous
        const rect = targetItem.getBoundingClientRect();
        const y = e.clientY - rect.top;
        const isTop = y < rect.height / 2;
        
        // Insère l'élément à la position appropriée
        if (isTop) {
            this.streamersList.insertBefore(sourceItem, targetItem);
        } else {
            this.streamersList.insertBefore(sourceItem, targetItem.nextSibling);
        }
        
        // Nettoie les classes
        this.clearDragIndicators();
        
        // Notifie du changement d'ordre
        if (typeof this.onOrderChange === 'function') {
            const newOrder = Array.from(this.streamersList.querySelectorAll('.streamer-item'))
                .map(item => item.dataset.streamerId);
            this.onOrderChange(newOrder);
        }
        
        // Mettre à jour les mini-streamers pour refléter le nouvel ordre
        this.updateMiniStreamers();
    }
    
    handleDragEnd(e) {
        this.streamersList.classList.remove('is-reordering');
        this.clearDragIndicators();
        // Nettoie toutes les classes liées au drag and drop
        document.querySelectorAll('.streamer-item').forEach(item => {
            item.classList.remove('dragging', 'drag-active', 'drop-above', 'drop-below');
            item.setAttribute('aria-grabbed', 'false');
        });
    }
    
    // Méthode pour initialiser les contrôles de chat
    initChatControls() {
        const globalChatBtn = document.getElementById('global-chat-toggle');
        const individualChatBtn = document.getElementById('individual-chat-toggle');
        
        if (globalChatBtn && individualChatBtn) {
            globalChatBtn.addEventListener('click', () => {
                this.activateChatMode('global');
            });
            
            individualChatBtn.addEventListener('click', () => {
                this.activateChatMode('individual');
            });
            
            // Initialiser l'état par défaut
            this.activateChatMode('global');
        }
    }
    
    // Méthode pour activer un mode de chat
    activateChatMode(mode) {
        const globalChatBtn = document.getElementById('global-chat-toggle');
        const individualChatBtn = document.getElementById('individual-chat-toggle');
        
        if (!globalChatBtn || !individualChatBtn) return;
        
        // Éviter les appels multiples si le mode est déjà actif
        const isGlobalActive = globalChatBtn.classList.contains('active');
        const isIndividualActive = individualChatBtn.classList.contains('active');
        
        if ((mode === 'global' && isGlobalActive) || (mode === 'individual' && isIndividualActive)) {
            return; // Mode déjà actif, ne rien faire
        }
        
        // Mettre à jour l'état visuel des boutons
        globalChatBtn.classList.toggle('active', mode === 'global');
        individualChatBtn.classList.toggle('active', mode === 'individual');
        
        // Activer le mode correspondant avec une vérification d'état
        if (mode === 'global') {
            // S'assurer que le mode individuel est désactivé avant d'activer le global
            if (window.app && window.app.globalChat) {
                // Forcer la désactivation du mode global d'abord pour nettoyer l'état
                if (window.app.globalChat.isGlobalMode) {
                    window.app.globalChat.disableGlobalChat();
                }
                // Puis activer le mode global
                if (typeof window.app.openGlobalChat === 'function') {
                    window.app.openGlobalChat();
                }
            }
        } else {
            // Mode individuel - s'assurer que le mode global est désactivé
            if (window.app && window.app.globalChat) {
                if (typeof window.app.globalChat.switchToIndividualMode === 'function') {
                    window.app.globalChat.switchToIndividualMode();
                } else if (window.app && typeof window.app.showDefaultChatMessage === 'function') {
                    window.app.showDefaultChatMessage();
                }
            }
        }
    }
    
    // Méthode pour initialiser les mini-streamers
    initMiniStreamers(callbacks) {
        this.miniStreamersCallbacks = callbacks || {};
        
        // Créer le conteneur pour les mini-streamers s'il n'existe pas déjà
        if (!this.miniStreamersContainer) {
            this.miniStreamersContainer = document.createElement('div');
            this.miniStreamersContainer.className = 'streamers-container';
            this.sidebar.appendChild(this.miniStreamersContainer);
        }
        
        // Observer les changements dans la liste des streamers
        this.streamerObserver = new MutationObserver(() => {
            this.updateMiniStreamers();
        });
        
        const streamerList = document.getElementById('streamer-list');
        if (streamerList) {
            this.streamerObserver.observe(streamerList, { 
                childList: true, 
                subtree: true 
            });
        }
        
        // Mettre à jour initialement
        this.updateMiniStreamers();
        
        // S'assurer que updateMiniStreamers est appelé lors du basculement de la sidebar
        this.oldToggleSidebar = this.toggleSidebar;
        this.toggleSidebar = () => {
            // Appeler l'ancienne méthode
            this.oldToggleSidebar();
            // Mettre à jour les mini-streamers
            this.updateMiniStreamers();
        };
        
        // Ajouter les gestionnaires pour le drag and drop
        this.miniStreamersContainer.addEventListener('dragover', (e) => {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
            const draggingItem = this.miniStreamersContainer.querySelector('.dragging');
            if (!draggingItem) return;
            
            const items = Array.from(this.miniStreamersContainer.querySelectorAll('.streamer-item-mini:not(.dragging)'));
            
            // Trouver l'élément sur lequel on plane
            const closest = items.reduce((closest, child) => {
                const box = child.getBoundingClientRect();
                const offset = e.clientY - (box.top + box.height / 2);
                
                if (offset < 0 && offset > closest.offset) {
                    return { offset: offset, element: child };
                } else {
                    return closest;
                }
            }, { offset: Number.NEGATIVE_INFINITY }).element;
            
            this.clearDragIndicators(this.miniStreamersContainer);

            if (closest) {
                closest.classList.add('drag-target-above');
                this.miniStreamersContainer.insertBefore(draggingItem, closest);
            } else {
                items.at(-1)?.classList.add('drag-target-below');
                this.miniStreamersContainer.appendChild(draggingItem);
            }
        });

        this.miniStreamersContainer.addEventListener('dragend', (e) => {
            const draggingItem = this.miniStreamersContainer.querySelector('.dragging');
            if (draggingItem) {
                draggingItem.classList.remove('dragging');
                draggingItem.setAttribute('aria-grabbed', 'false');
                this.miniStreamersContainer.classList.remove('is-reordering');
                this.clearDragIndicators(this.miniStreamersContainer);
                
                // Synchroniser l'ordre avec la liste principale
                if (this.onOrderChange) {
                    const newOrder = Array.from(this.miniStreamersContainer.querySelectorAll('.streamer-item-mini'))
                        .map(item => item.dataset.streamerId);
                    
                    // Réordonnancer dans la vue normale
                    newOrder.forEach((id, index) => {
                        const item = this.streamersList.querySelector(`.streamer-item[data-streamer-id="${id}"]`);
                        if (item) {
                            this.streamersList.appendChild(item);
                        }
                    });
                    
                    // Notifier du changement d'ordre
                    this.onOrderChange(newOrder);
                }
            }
        });

        // Ajouter des styles CSS pour la visualisation du drag
        this.miniStreamersContainer.addEventListener('drop', (e) => {
            e.preventDefault();
        });
    }

    // Méthode pour mettre à jour les mini-streamers
    updateMiniStreamers() {
        if (!this.miniStreamersContainer) return;
        
        // Vider le conteneur
        this.miniStreamersContainer.innerHTML = '';
        
        // Si la sidebar n'est pas en mode minimisé, ne rien faire de plus
        if (!this.sidebar.classList.contains('collapsed')) return;
        
        // Récupérer les streamers actifs
        const streamers = document.querySelectorAll('#streamer-list .streamer-item');
        let queueDividerAdded = false;
        
        streamers.forEach(streamer => {
            const streamerId = streamer.dataset.streamerId;
            const nameEl = streamer.querySelector('.streamer-name');
            const avatarEl = streamer.querySelector('.streamer-avatar');
            const gameEl = streamer.querySelector('.streamer-game');
            const viewerBadgeEl = streamer.querySelector('.streamer-viewers');
            
            if (!nameEl || !avatarEl || !gameEl) return;
            
            const streamerName = nameEl.textContent;
            const avatarSrc = avatarEl.src;
            const isLive = streamer.classList.contains('live');

            if (!isLive && !queueDividerAdded) {
                const divider = document.createElement('div');
                divider.className = 'mini-queue-divider';
                divider.title = t('stream.queue', { count: '' }).replace(/\s*[·.]\s*$/, '');
                divider.setAttribute('role', 'separator');
                divider.innerHTML = '<span></span><i class="fas fa-clock" aria-hidden="true"></i><span></span>';
                this.miniStreamersContainer.appendChild(divider);
                queueDividerAdded = true;
            }
            
            // Créer l'élément mini-streamer
            const miniStreamer = document.createElement('div');
            miniStreamer.className = `streamer-item-mini ${isLive ? 'live' : 'queued'}`;
            miniStreamer.dataset.streamerId = streamerId;
            miniStreamer.setAttribute('aria-label', `${streamerName} - ${gameEl.textContent}`);
            
            const avatar = document.createElement('img');
            avatar.className = 'streamer-avatar-mini';
            avatar.src = avatarSrc;
            avatar.alt = streamerName;

            const menu = document.createElement('div');
            menu.className = 'mini-streamer-menu';
            menu.setAttribute('role', 'menu');
            menu.setAttribute('aria-label', t('mini.actions', { name: streamerName }));

            const menuHeader = document.createElement('div');
            menuHeader.className = 'mini-streamer-menu-header';

            const menuTitle = document.createElement('div');
            menuTitle.className = 'mini-streamer-menu-title';
            menuTitle.textContent = streamerName;
            menuHeader.appendChild(menuTitle);

            if (isLive && viewerBadgeEl) {
                const menuViewers = document.createElement('div');
                menuViewers.className = 'mini-streamer-menu-viewers';
                menuViewers.title = viewerBadgeEl.title;

                const liveDot = document.createElement('span');
                liveDot.className = 'viewer-live-dot';
                liveDot.setAttribute('aria-hidden', 'true');

                const viewerCount = document.createElement('span');
                viewerCount.textContent = viewerBadgeEl.querySelector('.viewer-count')?.textContent || '';
                menuViewers.append(liveDot, viewerCount);
                menuHeader.appendChild(menuViewers);
            }

            menu.appendChild(menuHeader);

            const createAction = (label, iconClass, callback, danger = false, disabled = false) => {
                const button = document.createElement('button');
                button.type = 'button';
                button.className = `mini-streamer-menu-action${danger ? ' danger' : ''}`;
                button.disabled = disabled;
                button.innerHTML = `<i class="${iconClass}" aria-hidden="true"></i><span></span>`;
                button.querySelector('span').textContent = label;
                button.addEventListener('click', (event) => {
                    event.stopPropagation();
                    callback?.(streamerId);
                });
                menu.appendChild(button);
                return button;
            };

            createAction(t('stream.chat'), 'fas fa-comments', this.miniStreamersCallbacks.openChat);
            createAction(t('stream.focus'), 'fas fa-search-plus', this.miniStreamersCallbacks.focus, false, !isLive);
            createAction(t('stream.maximize'), 'fas fa-expand', this.miniStreamersCallbacks.maximize, false, !isLive);

            const volumeState = this.miniStreamersCallbacks.getVolumeState?.(streamerId) || { volume: 0.5, muted: true };
            const volumeRow = document.createElement('div');
            volumeRow.className = 'mini-streamer-volume';

            const muteButton = document.createElement('button');
            muteButton.type = 'button';
            muteButton.className = 'mini-streamer-volume-toggle volume-toggle';
            muteButton.dataset.volumeStreamerId = streamerId;
            muteButton.disabled = volumeState.available === false;
            muteButton.title = volumeState.muted ? t('audio.unmute') : t('audio.mute');
            muteButton.innerHTML = `<i class="fas ${volumeState.muted ? 'fa-volume-mute' : 'fa-volume-up'}" aria-hidden="true"></i>`;
            muteButton.addEventListener('click', (event) => {
                event.stopPropagation();
                this.miniStreamersCallbacks.toggleMuted?.(streamerId);
            });

            const volumeSlider = document.createElement('input');
            volumeSlider.type = 'range';
            volumeSlider.min = '0';
            volumeSlider.max = '100';
            volumeSlider.step = '5';
            volumeSlider.value = String(Math.round(volumeState.volume * 100));
            volumeSlider.dataset.volumeStreamerId = streamerId;
            volumeSlider.disabled = volumeState.available === false;
            volumeSlider.setAttribute('aria-label', `Volume de ${streamerName}`);
            volumeSlider.addEventListener('input', (event) => {
                event.stopPropagation();
                this.miniStreamersCallbacks.setVolume?.(streamerId, Number(volumeSlider.value) / 100);
            });

            const volumeValue = document.createElement('span');
            volumeValue.className = 'volume-value';
            volumeValue.dataset.volumeStreamerId = streamerId;
            volumeValue.textContent = volumeState.muted ? t('audio.muted') : `${Math.round(volumeState.volume * 100)}%`;
            volumeRow.append(muteButton, volumeSlider, volumeValue);
            menu.appendChild(volumeRow);

            createAction(t('common.remove'), 'fas fa-trash', (id) => {
                this.miniStreamersCallbacks.removeStreamer?.(id);
                miniStreamer.remove();
            }, true);

            menu.addEventListener('mousedown', (event) => event.stopPropagation());
            menu.addEventListener('dragstart', (event) => event.preventDefault());
            miniStreamer.append(avatar, menu);
            
            // Ajouter les fonctionnalités de drag and drop
            miniStreamer.draggable = true;
            
            miniStreamer.addEventListener('dragstart', (e) => {
                e.stopPropagation();
                e.dataTransfer.setData('text/plain', streamerId);
                e.dataTransfer.effectAllowed = 'move';
                miniStreamer.setAttribute('aria-grabbed', 'true');
                this.miniStreamersContainer.classList.add('is-reordering');
                miniStreamer.classList.add('dragging');
            });
            
            this.miniStreamersContainer.appendChild(miniStreamer);
        });
    }
}
